// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resultpage_content__-7CdQ {
  margin-top: 70px;
  padding: 0 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.resultpage_header_button__Q6MST {
  display: none;
}

.resultpage_rounds__FeZhf {
  margin: 0 auto;
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.resultpage_round__B70ia {
  border: 2px solid white;
  border-radius: 50%;
  background-color: #2FD414;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.resultpage_round_wrong__AowDD {
  background-color: #F8521D;
  border: 2px solid white;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  margin-right: 9px;
}

.resultpage_header__D-Re- {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--font-rubik);
  font-size: 32px;
  line-height: 38px;
  color: #CCFFD1;
  font-weight: 500;
  padding: 20px 169px;
  border-radius: 25px;
  background-color: #3DA452;
  border: 2px solid #7EDB88;
  margin-bottom: 28px;
}

.resultpage_answers__AshQe {
  display: flex;
  justify-content: center;
  margin-bottom: 58px;
  column-gap: 20px;
}

.resultpage_answer__PiL74 {
  border: 3px solid #67D650;
  border-radius: 12px;
  font-size: 128px;
  line-height: 150px;
  font-family: var(--font-rubik);
  font-weight: 500;
  color: #066610;
  width: 304px;
  height: 304px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom, #AFFFB7 0%, #57D464 60%, #8CED95 100%);
}

.resultpage_answer_wrong__CxPxc {
  background: linear-gradient(to bottom, #FFCDCD 0%, #EF8787 60%, #FBA7A7 100%);
  color: #A4310D;
  border: 3px solid #D45757;
}

.resultpage_header_block__l9SEV img {
  width: auto;
}

.resultpage_orange_button__co0Yp {
  width: 300px;
}

@media screen and (max-width: 1300px) {
  .resultpage_header_button__Q6MST {
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .resultpage_rounds__FeZhf {
    width: 80%;
  }
}
@media screen and (max-width: 665px) {
  .resultpage_answer__PiL74 {
    width: 161px;
    height: 161px;
    font-size: 48px;
    line-height: 56px;
  }
  .resultpage_header__D-Re- {
    font-size: 20px;
    line-height: 24px;
    border-radius: 12px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
@media screen and (max-width: 600px) {
  .resultpage_content__-7CdQ {
    padding: 0;
    margin-top: 24px;
  }
  .resultpage_round_completed__HNDbs {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .resultpage_round__B70ia {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }
  .resultpage_round_wrong__AowDD {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .resultpage_answer__PiL74 {
    width: 161px;
    height: 161px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tests/testpage/resultpage/resultpage.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6EAAA;AACF;;AAEA;EACE,6EAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAGE;EACE,WAAA;AAAJ;;AAIA;EACE,YAAA;AADF;;AAIA;EACE;IACE,cAAA;EADF;AACF;AAIA;EACE;IACE,UAAA;EAFF;AACF;AAKA;EACE;IACE,YAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;EAHF;EAMA;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;IACA,oBAAA;EAJF;AACF;AAOA;EAEE;IACE,UAAA;IACA,gBAAA;EANF;EASA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAPF;EAUA;IACE,iBAAA;IACA,WAAA;IACA,YAAA;EARF;EAWA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EATF;EAYA;IACE,YAAA;IACA,aAAA;EAVF;AACF","sourcesContent":[".content {\n  margin-top: 70px;\n  padding: 0 250px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.header_button {\n  display: none;\n}\n\n.rounds {\n  margin: 0 auto;\n  width: 60%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.round {\n  border: 2px solid white;\n  border-radius: 50%;\n  background-color: #2FD414;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.round_wrong {\n  background-color: #F8521D;\n  border: 2px solid white;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  margin-right: 9px;\n}\n\n.header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: var(--font-rubik);\n  font-size: 32px;\n  line-height: 38px;\n  color: #CCFFD1;\n  font-weight: 500;\n  padding: 20px 169px;\n  border-radius: 25px;\n  background-color: #3DA452;\n  border: 2px solid #7EDB88;\n  margin-bottom: 28px;\n}\n\n.answers {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 58px;\n  column-gap: 20px;\n}\n\n.answer {\n  border: 3px solid #67D650;\n  border-radius: 12px;\n  font-size: 128px;\n  line-height: 150px;\n  font-family: var(--font-rubik);\n  font-weight: 500;\n  color: #066610;\n  width: 304px;\n  height: 304px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(to bottom, #AFFFB7 0%, #57D464 60%, #8CED95 100%);\n}\n\n.answer_wrong {\n  background: linear-gradient(to bottom, #FFCDCD 0%, #EF8787 60%, #FBA7A7 100%);\n  color: #A4310D;\n  border: 3px solid #D45757;\n}\n\n.header_block {\n  img {\n    width: auto;\n  }\n}\n\n.orange_button {\n  width: 300px;\n}\n\n@media screen and (max-width: 1300px) {\n  .header_button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .rounds {\n    width: 80%;\n  }\n}\n\n@media screen and (max-width: 665px) {\n  .answer {\n    width: 161px;\n    height: 161px;\n    font-size: 48px;\n    line-height: 56px;\n  }\n\n  .header {\n    font-size: 20px;\n    line-height: 24px;\n    border-radius: 12px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .content {\n    padding: 0;\n    margin-top: 24px;\n  }\n\n  .round_completed {\n    width: 16px;\n    height: 16px;\n    margin-right: 6px;\n  }\n\n  .round {\n    margin-right: 6px;\n    width: 16px;\n    height: 16px;\n  }\n\n  .round_wrong {\n    width: 16px;\n    height: 16px;\n    margin-right: 6px;\n  }\n\n  .answer {\n    width: 161px;\n    height: 161px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `resultpage_content__-7CdQ`,
	"header_button": `resultpage_header_button__Q6MST`,
	"rounds": `resultpage_rounds__FeZhf`,
	"round": `resultpage_round__B70ia`,
	"round_wrong": `resultpage_round_wrong__AowDD`,
	"header": `resultpage_header__D-Re-`,
	"answers": `resultpage_answers__AshQe`,
	"answer": `resultpage_answer__PiL74`,
	"answer_wrong": `resultpage_answer_wrong__CxPxc`,
	"header_block": `resultpage_header_block__l9SEV`,
	"orange_button": `resultpage_orange_button__co0Yp`,
	"round_completed": `resultpage_round_completed__HNDbs`
};
export default ___CSS_LOADER_EXPORT___;
